module.exports = __webpack_public_path__ + "img/電気回路_6_2_1.2a472ce3.png";